import { render, staticRenderFns } from "./HomeIdDeudor.vue?vue&type=template&id=4229aa08&"
import script from "./HomeIdDeudor.vue?vue&type=script&lang=js&"
export * from "./HomeIdDeudor.vue?vue&type=script&lang=js&"
import style0 from "./HomeIdDeudor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports